import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Snackbar from "@mui/material/Snackbar";
import Stack from "@mui/material/Stack";
import { useDict } from "lib/dict";

export type ReleaseNoticeKind = "update" | "stale";

type Props = {
  kind: ReleaseNoticeKind | null;
  onReload: () => void;
  onGoTop: () => void;
  onClose: () => void;
};

// 新しい版の公開を知らせる。未保存の入力を消さないよう、再読み込みは利用者の操作で行う。
// 旧画面の契約エラー（stale）は、操作が失敗した理由もあわせて示す。
// 閉じている間は dict を参照しない（/404 の prerender など dict の無いページで落とさない）。
const ReleaseUpdateNotice = (props: Props) => (props.kind === null ? null : <OpenNotice {...props} kind={props.kind} />);

const OpenNotice = ({ kind, onReload, onGoTop, onClose }: Props & { kind: ReleaseNoticeKind }) => {
  const { d } = useDict();
  return (
    <Snackbar open anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
      <Alert
        severity={kind === "stale" ? "warning" : "info"}
        action={
          <Stack direction="row" spacing={1}>
            <Button color="inherit" size="small" onClick={onReload}>
              {d("common:release_update.reload")}
            </Button>
            <Button color="inherit" size="small" onClick={onGoTop}>
              {d("common:release_update.go_top")}
            </Button>
            {/* action を渡すと Alert 標準の×ボタンが出ないので、自前で置く */}
            <IconButton color="inherit" size="small" aria-label={d("common:button.close")} onClick={onClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Stack>
        }
      >
        {kind === "stale" ? d("common:release_update.stale_error") : d("common:release_update.available")}
      </Alert>
    </Snackbar>
  );
};

export default ReleaseUpdateNotice;
